// src/loading.tsx

import React from 'react';
import { Spin } from 'antd'; 


const Loading: React.FC = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100%',
    }}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <img
        src="/Logo.png"
        alt="Loading..."
        style={{
          width: '150px',
          height: 'auto',
        }}
      />
      <Spin size="large" style={{ marginTop: '20px' }} />
    </div>
  </div>
);

export default Loading;